import { motion } from 'framer-motion';
import { Button } from '../../ui/button';
import { ShieldCheck } from '@phosphor-icons/react';

export const DisclaimerModal = ({ onAccept, onDecline }) => {
  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/60 backdrop-blur-sm p-4">
      <motion.div 
        initial={{ opacity: 0, scale: 0.95 }}
        animate={{ opacity: 1, scale: 1 }}
        className="bg-white rounded-2xl p-6 sm:p-8 max-w-2xl w-full shadow-2xl max-h-[90vh] overflow-y-auto"
      >
        <div className="flex items-center gap-3 mb-6">
          <div className="w-14 h-14 rounded-full bg-gradient-to-br from-[#5B21B6] to-[#EC4899] flex items-center justify-center flex-shrink-0">
            <ShieldCheck className="w-7 h-7 text-white" weight="duotone" />
          </div>
          <div>
            <h3 className="text-xl font-bold text-[#0F172A]">Important Disclaimer</h3>
            <p className="text-sm text-[#64748B]">Please read carefully before proceeding</p>
          </div>
        </div>
        
        <div className="bg-[#F8FAFC] rounded-xl p-5 mb-6 border border-[#E2E8F0]">
          <p className="text-[#334155] leading-relaxed text-sm sm:text-base">
            <strong className="text-[#0F172A]">Menopath.ai</strong> is provided for <strong>informational and educational purposes only</strong>. It is not intended to diagnose, treat, cure, prevent, or predict any medical or health condition, nor to replace professional medical advice, diagnosis, or treatment.
          </p>
          <p className="text-[#334155] leading-relaxed text-sm sm:text-base mt-4">
            All results, insights, and recommendations generated by this platform are <strong>subjective, generalized, and may not be accurate or applicable to every individual</strong>.
          </p>
          <p className="text-[#334155] leading-relaxed text-sm sm:text-base mt-4">
            <strong>Always consult a qualified healthcare professional</strong> regarding any medical concerns or decisions. Use of this website and its content is at your own risk.
          </p>
          <p className="text-[#334155] leading-relaxed text-sm sm:text-base mt-4">
            Menopath.ai and its owners <strong>disclaim all liability</strong> for actions taken or not taken based on the information provided.
          </p>
        </div>
        
        <div className="flex flex-col sm:flex-row gap-3">
          <Button 
            onClick={onDecline} 
            variant="outline"
            className="flex-1 border-2 border-[#E2E8F0] text-[#64748B] hover:bg-[#F1F5F9] rounded-xl h-12"
          >
            I Do Not Agree
          </Button>
          <Button 
            onClick={onAccept} 
            className="flex-1 bg-gradient-to-r from-[#5B21B6] to-[#7C3AED] hover:opacity-90 rounded-xl h-12 font-semibold"
          >
            I Agree & Continue
          </Button>
        </div>
        
        <p className="text-xs text-[#94A3B8] text-center mt-4">
          By clicking "I Agree & Continue", you acknowledge that you have read and understood this disclaimer.
        </p>
      </motion.div>
    </div>
  );
};
